export class PecDTO {
  pec: string;
}
